module.exports = "/images/Building---Screenshots.jpg";